import React from "react";
import { createFileRoute, Navigate } from "@tanstack/react-router";

export const Route = createFileRoute("/members/")({
  component: () => <Navigate to="/members/enroll" />,
});
